import axios from 'axios';
import { polusBaseUrl, POST } from '../../utils/axios-interceptor';
import { orgScopedHeaders } from '../../utils/constants/commonConstants';
import { getTimeStamp } from '../../utils/dateUtils';
import type { DataAvailabilityRequestPayload, DataAvailabilityWindow, ReconciliationsRequestPayload } from './types';

const RECONCILIATIONS_URL = 'unifier/reconciliations';
const DATA_AVAILABILITY_URL = 'unifier/dataAvailability';

export async function fetchReconciliations(
    orgId: string,
    fys: number[] | null,
    drillDown: { reconId: string; fy: number } | null,
): Promise<unknown> {
    // `sections` stays on the wire — the server earns it — but scope is a display-only filter over
    // the one shared payload (D6-C), so no caller here ever has a value for it.
    const requestPayload: ReconciliationsRequestPayload = {
        requestId: getTimeStamp(),
        fys,
        sections: null,
        drillDown,
    };

    const response = await axios({
        baseURL: polusBaseUrl,
        url: RECONCILIATIONS_URL,
        method: POST,
        headers: orgScopedHeaders(orgId),
        data: { requestPayload },
    });

    return response?.data;
}

export async function fetchDataAvailability(orgId: string, fy: number | null, window: DataAvailabilityWindow | null): Promise<unknown> {
    const requestPayload: DataAvailabilityRequestPayload = { requestId: getTimeStamp(), fy, window };

    const response = await axios({
        baseURL: polusBaseUrl,
        url: DATA_AVAILABILITY_URL,
        method: POST,
        headers: orgScopedHeaders(orgId),
        data: { requestPayload },
    });

    return response?.data;
}
